import { useQuery } from '@tanstack/react-query'

import { get } from '@/lib/api'

import { lifecycleKeys } from './use-employee-lifecycle'

import type { Employee } from './use-employees'

// ==================== Types ====================

export interface EmployeeStats {
  total: number
  byStatus: {
    active: number
    resigned: number
    onLeave: number
  }
  recentHires: Array<{
    employee: Employee
    onboardingProgress: number
  }>
  upcomingDepartures: Employee[]
  currentlyOnLeave: Employee[]
  incompleteProfiles: Employee[]
  recentResignations: Employee[]
}

// ==================== Hooks ====================

/**
 * 获取员工统计数据
 */
export function useEmployeeStats() {
  return useQuery({
    queryKey: lifecycleKeys.stats(),
    queryFn: () => get<EmployeeStats>('/hr/employees/lifecycle/stats'),
  })
}
